import { apiClient } from "./httpClient";
import { unwrapEnvelope, unwrapList, unwrapMeta } from "./response";

export const reportsApi = {
  async list(params = {}) {
    const response = await apiClient.get("/reports", { params });
    return { data: unwrapList(response.data), meta: unwrapMeta(response.data) };
  },

  async count(params = {}) {
    const response = await apiClient.get("/reports/count", { params });
    return unwrapEnvelope(response.data, { count: 0 });
  },

  async create(payload) {
    const response = await apiClient.post("/reports", payload);
    return unwrapEnvelope(response.data, null);
  },

  async update(id, payload) {
    const response = await apiClient.put(`/reports/${id}`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async remove(id) {
    const response = await apiClient.delete(`/reports/${id}`);
    return unwrapEnvelope(response.data, null);
  }
};
